// Real Google reviews for Son's Guadalupe.
// Lightly trimmed for length; wording, names, ratings, and dates preserved.
// Source: Google Maps reviews (https://maps.app.goo.gl/XifRuHwedNFxMS16A)

export type Testimonial = {
  author: string;
  rating: 5 | 4 | 3 | 2 | 1;
  date: string; // ISO YYYY-MM-DD (approximate where Google shows "X months ago")
  body: string;
  highlight?: string; // short pull-quote for card header
  category: "glamping" | "cabanas" | "tubing" | "family" | "service";
};

export const testimonials: Testimonial[] = [
  {
    author: "Karen Jordan",
    rating: 5,
    date: "2025-08-15",
    category: "glamping",
    highlight: "We wanted a camping experience with just a little glam — and that's exactly what we got.",
    body:
      "I decided to step out of my comfort zone and book an overnight stay in one of their glamping tents for my family of 4. From booking to checking out, the experience was amazing. The drive there provided incredible scenery. Upon my arrival I was greeted by a very kind and polite young lady who made herself available and even checked on us while at the river. The tents have AC, a fan, two queens and a twin — comfortable and cool once the sun went down. At night, we were surrounded by the sounds of nature and the glow of fire flies. It was perfect! I can't wait to explore the other locations.",
  },
  {
    author: "Summer Deist",
    rating: 5,
    date: "2025-07-20",
    category: "family",
    highlight: "We come here every year — and this weekend was the best so far.",
    body:
      "Wow! I really enjoyed my weekend with my family at Son's Guadalupe! Father's Day was perfect — not over crowded, and we tried everything: day cabana, glamping tent, and picnic table. The water is clear and moving for tubing! Everything was clean and organized from the bathrooms to tubing timing. My husband grills all of our meals and Son's has everything he needed from sunblock and charcoal to a spatula. Kat the on-site manager handles everything perfectly — when a thunderstorm rolled in she cleared the water, advised everyone, and even helped move coolers. Booking my return trip already.",
  },
  {
    author: "Heidy Perez",
    rating: 5,
    date: "2025-08-01",
    category: "cabanas",
    highlight: "Grill under the shade of a cabana, then float the river — exactly what we needed.",
    body:
      "Our first trip to Son's Guadalupe and it was great! We went with a group of friends and a toddler. Being able to grill under the shade of a cabana and then take some time to float the river was just what we all needed. I highly recommend taking a visit to cool off this summer! Oh, and don't forget your water shoes for the river — they are a must!",
  },
  {
    author: "Matthew Guynes",
    rating: 5,
    date: "2025-09-02",
    category: "glamping",
    highlight: "The tents were spacious and the AC worked well. The location was great.",
    body:
      "Exactly what I would expect for a glamping experience. Remember, this is not a hotel — you are still camping — but the tents were spacious and the AC worked well. The location was great! We met the property manager Kat and she took very good care of us and the property. It was a very busy weekend over Labor Day, but everything seemed to flow smoothly. This place is lucky to have Kat as its manager!",
  },
  {
    author: "Arnulfo Castillo",
    rating: 5,
    date: "2025-07-10",
    category: "cabanas",
    highlight: "The cabanas have faucets, plugs, fans with light. Grills and firepits for everyone.",
    body:
      "On-site manager loves her job and is ready within seconds with any questions or concerns. Very friendly. Glamping tents were awesome. The location on the river has enough shade and shallow areas to relax in. The cabanas have faucets, plugs, fans with light. Grills and firepits for everyone to enjoy. Will definitely return and recommend to friends and family.",
  },
  {
    author: "Lauren Shelton",
    rating: 5,
    date: "2024-07-15",
    category: "tubing",
    highlight: "An unforgettable experience — already making plans to go back next year.",
    body:
      "We were excited to arrive and check in at the red building with Tyler, who was super helpful the entire trip. The tents were great — comfortable beds, AC, and fans kept us cool in the summer heat. We mostly hung out in the cabanas together but the picnic tables were nice for meal prep and card games. The little river entrance right next to our cabanas made running down to the water easy. The van ride to the tubing entrance was quick and we had no problem getting in the water. Overall, we had an unforgettable experience — already making plans to go back next year.",
  },
  {
    author: "Melissa Hargrove",
    rating: 5,
    date: "2024-06-10",
    category: "tubing",
    highlight: "We won't use any other tubing/rafting company.",
    body:
      "We have gone to Son's Guadalupe for the past 3 years! We won't use any other tubing/rafting company. They are wonderful to work with and our river trips have always been awesome!",
  },
  {
    author: "Jessica Anderson",
    rating: 5,
    date: "2023-09-02",
    category: "tubing",
    highlight: "Tyler was phenomenal — checked us in, showed us our spot, drove us to tubing.",
    body:
      "My family and I stayed here for Labor Day weekend. We had such a great time. The guy Tyler that runs this place was phenomenal! He does EVERYTHING! He checked us in, showed us our spot, brought us to our tubing location, on top of cleaning all the camps!",
  },
  {
    author: "Lydia Garza",
    rating: 5,
    date: "2023-08-24",
    category: "tubing",
    highlight: "Great family time at Son's of Guadalupe — my family enjoyed tubing.",
    body:
      "Great family time at Son's of Guadalupe! Tyler was super helpful. My family enjoyed tubing.",
  },
  {
    author: "Isabel Rodriguez",
    rating: 5,
    date: "2023-11-25",
    category: "glamping",
    highlight: "Our tent had everything we needed — personal hammock, grill station, and picnic table.",
    body:
      "River tubing was soooo much fun! Our tent was equipped with everything we needed for our weekend stay. Personal hammock, grill station and picnic table too! We'll be back again and again!",
  },
];
